// extracted by mini-css-extract-plugin
export default {"service-card":"service-card_service-card__pd5uW","image-wrapper":"service-card_image-wrapper__Irjj8"};